import { useTranslation } from 'react-i18next';
import LegalDocument, { LegalLayout } from 'pages/legal-document/LegalDocument';
import { LegalDocumentKind } from 'utils/legalDocuments';
import './LegalDocument.scss';

export const TermsPage = () => <LegalDocument kind={LegalDocumentKind.TermsAndConditions}/>;
export const PrivacyPage = () => <LegalDocument kind={LegalDocumentKind.PrivacyPolicy}/>;
export const CookiesPage = () => <LegalDocument kind={LegalDocumentKind.CookiePolicy}/>;
export const SizesChartPage = () => <LegalDocument kind={LegalDocumentKind.SizesChart}/>;

/** The return policy is plain text in the translations, so it is rendered as text, not as a PDF. */
export const ReturnsPage = () => {
  const { t } = useTranslation();
  const paragraphs: string[] = String(t('footer.returnPolicyText')).split(/\n+/).filter(Boolean);

  return (
    <LegalLayout title={t('footer.returnPolicy')} description={paragraphs[0]}>
      {paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}
    </LegalLayout>
  );
};
